import { Fragment, useState } from 'react';
import Modal, { ModalProps } from './Modal';

import Button from '../common/Button';
import { ModalResponse } from '../../enum/ModalResponse';
import { routes } from '../../routes';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export interface ModalDeclineTermsAndConditionProps extends ModalProps {}
export default function ModalDeclineTermsAndCondition({
  isOpen,
  onClickAction,
}: ModalDeclineTermsAndConditionProps) {
  const { t } = useTranslation();
  const [modalResponse, setModalResponse] = useState<ModalResponse | undefined>();
  const navigate = useNavigate();

  const handleClickNo = () => {
    setModalResponse(ModalResponse.CANCEL);
    if (onClickAction) {
      onClickAction(ModalResponse.CANCEL);
    }
  };

  const handleClickYes = () => {
    setModalResponse(ModalResponse.OK);
    if (onClickAction) {
      onClickAction(ModalResponse.OK);
    }
  };

  const handleOnClose = (response: ModalResponse | undefined) => {
    if (response === ModalResponse.CANCEL) {
      navigate(`${routes.SIGN_OUT.path}${window.location.search}`);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => handleOnClose(modalResponse)}
      actions={
        <Fragment>
          <Button className="btn btn--secondary mr-4 modal__actions__first" onClick={handleClickNo}>
            {t('modal.terms.condition.decline.btn.no')}
          </Button>
          <Button className="btn btn--primary" onClick={handleClickYes}>
            {t('modal.terms.condition.decline.btn.yes')}
          </Button>
        </Fragment>
      }
    >
      <Fragment>
        <p className="modal__message">{t('modal.terms.condition.decline.message.one')}</p>
        <p className="modal__message">{t('modal.terms.condition.decline.message.two')}</p>
      </Fragment>
    </Modal>
  );
}
